import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const EventInfoContainer = styled.div`
  .mini-hotel-code {
    input {
      text-transform: uppercase;
    }
    .icon-spinner {
      position: absolute;
      right: ${toRem(13)};
      top: ${toRem(10)};
      left: auto;
      left: initial;
      font-size: ${toRem(20)};
    }
  }
`;
